import { RoleState } from './roles.state'

export class RoleSelectors {
  static selectRoles(state: RoleState) {
    return state.entities
  }

  static selectIsLoading(state: RoleState) {
    return state.isLoading
  }

  static selectError(state: RoleState) {
    return state.error
  }
}
